import {createSvgIcon} from "@mui/material";

export const UploadLayoutIcon = createSvgIcon(
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.3337 23.3334L35.0003 11.6667M35.0003 11.6667L46.667 23.3334M35.0003 11.6667V46.6667M11.667 58.3334H58.3337" stroke="#C8DBFC" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'UploadLayoutIcon'
)